export default __webpack_public_path__ + "static/use-for-free-11d21747533b64f53454a384a7fb9107.png";